import type { FC } from 'react'

import { useRundownPageSnap } from '../../rundown-page.store'

import { useGroupTiming, useGroupTimestamps } from './group.hooks'
import type { GroupChildren } from './group.types'
import { GroupPlannedDuration } from './GroupPlannedDuration'
import { GroupPlannedTimeRange } from './GroupPlannedTimeRange'
import { GroupTimingsRow } from './GroupTimingsRow'

type GroupPlannedTimingsProps = {
  childrenCues: GroupChildren
}

export const GroupPlannedTimings: FC<GroupPlannedTimingsProps> = ({
  childrenCues,
}) => {
  const { rundown } = useRundownPageSnap()
  const groupTimestamps = useGroupTimestamps(childrenCues)
  const groupTiming = useGroupTiming(groupTimestamps)
  if (!groupTiming) return null

  return (
    <GroupTimingsRow
      Duration={<GroupPlannedDuration groupTiming={groupTiming} />}
      Range={
        <GroupPlannedTimeRange
          groupTiming={groupTiming}
          timezone={rundown.timezone}
          todDisplayFormat={rundown.settings?.todDisplayFormat}
        />
      }
    />
  )
}
